module.exports = __webpack_public_path__ + "img/empty-result.b63d9d2c.png";